module.exports = __webpack_public_path__ + "img/gstar.5b6ac9d4.svg";